// eslint-disable-next-line import/prefer-default-export, no-shadow
  export enum TrimLevelsActionTypes {
    GET_TRIM_LEVELS = 'GET_TRIM_LEVELS',
  }
  